import React, { useState, useEffect } from 'react';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { AppSearchSelect } from '@sde/widgets-core/src/widgets/AppSearchSelect';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { getUserPermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import PropTypes from 'prop-types';

export const AppSearch = ({ onSearch }) => {
  const router = useRouter();
  const { user } = useUser.state();

  const widgetProps = {
    data: { user },
    events: {},
  };

  const onItemSelect = (searchTerm) => {
    onSearch();
    const encodedSearchTerm = encodeURIComponent(searchTerm);
    router.navigate(`/app-search/${encodedSearchTerm}`);
  };

  return <AppSearchSelect onItemSelect={onItemSelect} {...widgetProps} />;
};

AppSearch.propTypes = {
  onSearch: PropTypes.func,
};

AppSearch.defaultProps = {
  onSearch: () => {},
};
